module.exports = __webpack_public_path__ + "static/media/battle-bots-ads.92a4f6b8.png";